import { render, staticRenderFns } from "./Minimum.vue?vue&type=template&id=1a270b4e&"
import script from "./Minimum.vue?vue&type=script&lang=js&"
export * from "./Minimum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports